import React, { Component } from "react";
import { connect } from "react-redux";
import { Row, Col } from "react-bootstrap";
import './reportshipping.css';

const mapStateToProps = state => ({
    userId: state.authState.username,
    role: state.authState.role,
    permissions: state.authState.userPermissions
});

class ReportingShippingNew extends Component {
    render() {
        // Use the store-specific URL from props, or fallback to the default URL
        const reportUrl = this.props.reportUrl || "";

        return (
            <div className="shipping-report">
                <Row>
                    <Col sm={3}>
                        <h1 className="heading-text" style={{ marginBottom: '20px' }}>Order Reporting</h1>
                    </Col>
                </Row>

                <div className="looker-report-container" style={{ width: '100%', height: 'calc(100vh - 100px)' }}>
                    <iframe 
                        src={reportUrl}
                        frameBorder="0"
                        style={{ width: '100%', height: '100%' }}
                        allowFullScreen
                    />
                </div>
            </div>
        );
    }
}

const shippingReport = connect(mapStateToProps)(ReportingShippingNew);
export default shippingReport;